import React, {useEffect, useState} from "react";
import STC from "../../STCFactory/STCFactory";
import { LookUpAPIs } from "../../../API/LookUpAPIs/LookUpAPIs";
import { parseWithOptions } from "date-fns/fp";

function DestinationDropDown(props){


    const [loading, setLoading] = useState(true);
    const [destinationData, setDestinationData] = useState([]);


    const getDestinationData = () => {

        LookUpAPIs.GetDestinations()
            .then((response) => {
                if(response.status === 200){
                    setDestinationData(response.data);
                    
                    setLoading(false)
                }
                else{
                    console.log(response.status);
                }
            })
            .catch((err) => {
                console.log('ERROR: ', err.message);
            });

    }

    useEffect(() => {
        getDestinationData();
        },[loading]
    )

    if(loading){
        return(
            <STC.Form.Select
                className={props.className}
                size={props.size}
                disabled={props.disabled}
                id={props.id}
            >
                <option>Loading...</option>
            </STC.Form.Select>
        )
    }

    else{
        return(

            <STC.Form.Select
                disabled={props.disabled}
                className={props.className}
                value={props.value}
                required={props.required}
                onChange={props.onChange}
                size={props.size}
                isInvalid={props.isInvalid}
                isValid={props.isValid}
                id={props.id}
            >
                <option selected disabled value={""}>Destination</option>
                {destinationData.length > 0 ? destinationData.map((data, index) => {
                    if(data.charAt(0).toLowerCase() !== 'x' || data.split('-')[0] === 'Xian '){
                        return(
                        <option key={index} value={data}>{data}</option>
                        )
                    }

                }) : <p></p>}
            </STC.Form.Select>

        );
    }


}
export default DestinationDropDown;